const validarImagen = async (file) => {
  // Validar que sea un archivo
  if (!(file instanceof File)) {
    return {
      isValid: false,
      error: 'El input debe ser un archivo válido'
    };
  }

  // Validar el tipo MIME
  const validImageTypes = [
    'image/jpeg',
    'image/png'
  ];
  
  if (!validImageTypes.includes(file.type)) {
    return {
      isValid: false,
      error: `Tipo de archivo no permitido: ${file.type}. Solo se permiten: ${validImageTypes.join(', ')}`
    };
  }

  // Validar tamaño máximo (2MB)
  const maxSize = 2 * 1024 * 1024;
  if (file.size > maxSize) {
    return {
      isValid: false,
      error: `El archivo excede el tamaño máximo permitido de 2MB`
    };
  }

  try {
    // Validar dimensiones
    const imageInfo = await getImageMetadata(file);
    
    const minDimension = 100;
    const maxDimension = 2000;
    
    if (imageInfo.width < minDimension || imageInfo.height < minDimension) {
      return {
        isValid: false,
        error: `Imagen muy pequeña. Dimensiones mínimas: ${minDimension}x${minDimension} px`
      };
    }
    
    if (imageInfo.width > maxDimension || imageInfo.height > maxDimension) {
      return {
        isValid: false,
        error: `Imagen muy grande. Dimensiones máximas: ${maxDimension}x${maxDimension} px`
      };
    }

    // Validar proporción de aspecto
    const aspectRatio = imageInfo.width / imageInfo.height;
    const maxAspectRatioDeviation = 2;
    
    if (aspectRatio > maxAspectRatioDeviation || aspectRatio < 1/maxAspectRatioDeviation) {
      return {
        isValid: false,
        error: 'Proporcion de imagen muy grande'
      };
    }

    // Verificar contenido sospechoso
    const suspiciousContent = await analyzeSuspiciousMetadata(file);
    if (suspiciousContent.length > 0) {
      return {
        isValid: false,
        error: `La imagen subida no es segura`
      };
    }

    // Si pasa todas las validaciones
    return {
      isValid: true,
      error: null
    };

  } catch (error) {
    return {
      isValid: false,
      error: 'Ocurrio un error al procesar la imagen'
    };
  }
};


const getImageMetadata = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (event) => {
      const img = new Image();
      
      img.onload = () => {
        resolve({
          width: img.width,
          height: img.height
        });
      };
      
      img.onerror = () => {
        reject(new Error('No se pudo cargar la imagen'));
      };
      
      img.src = event.target.result;
    };
    
    reader.onerror = () => {
      reject(new Error('Error al leer el archivo'));
    };
    
    reader.readAsDataURL(file);
  });
};


const analyzeSuspiciousMetadata = async (file) => {
  const suspiciousPatterns = [
    /<script/i,
    /javascript:/i,
    /data:text\/html/i,
    /data:application\/javascript/i,
    /data:application\/x-javascript/i,
    /data:text\/javascript/i,
    /data:text\/xml/i,
    /&#x/i,
    /\\x[0-9a-f]{2}/i,
    /eval\(/i,
    /function\(/i,
    /onclick/i,
    /onload/i,
    /onerror/i,
  ];

  try {
    const buffer = await file.slice(0, 1024).arrayBuffer();
    const content = new TextDecoder().decode(buffer);

    // Verificar patrones sospechosos
    for (const pattern of suspiciousPatterns) {
      if (pattern.test(content)) {
        return ['La imagen subida no es segura'];
      }
    }

    // Verificar magic numbers
    const uint8Array = new Uint8Array(buffer);
    const magicBytes = Array.from(uint8Array.slice(0, 4))
      .map(byte => byte.toString(16).padStart(2, '0'))
      .join('');
    
    const validMagicNumbers = {
      'ffd8ff': 'JPEG',
      '89504e47': 'PNG'
    };

    let isValidMagicNumber = false;
    for (const [magic, format] of Object.entries(validMagicNumbers)) {
      if (magicBytes.startsWith(magic)) {
        isValidMagicNumber = true;
        break;
      }
    }

    if (!isValidMagicNumber) {
      return ['La imagen subida no es segura'];
    }

    return [];

  } catch (error) {
    throw new Error(`Ocurrio un error al procesar la imagen`);
  }
};

  export default validarImagen;